module.exports = __webpack_public_path__ + "td/img/logo.4e442086.png";